import getDFPBlock from "../../utils/getDFPBlock";

export default function (newsIndex){
    if(newsIndex === 1){
        let readMoreWidget = document.getElementsByClassName('read-also')[0];
        if(readMoreWidget !== null && typeof readMoreWidget !== "undefined"){
            let advPlace = document.createElement('div');
            advPlace.style.minHeight = '100px';
            advPlace.id = 'maraton-in-news';

            if (document.getElementById(advPlace.id) !== null) {
                return;
            }

            readMoreWidget.after(advPlace);

            getDFPBlock('/56301415/24tv_sport_800x70_desktop', [1, 1], advPlace.id);
        }
    }
}